module.exports = "/_next/static/images/CdpReport2023-67d71bf82e7975298fac5cd581c8ad5e.png";